import { defineStore } from 'pinia'

import ApiServiceV1 from '../api/adminApi/AdminApiV1'
import RetailApiV2 from '../api/retailApi/RetailApiV2'
import type { Product } from '@/types/product'

interface IProductStore {
  filters: string[]
  crossSell: unknown | null
  goodDeeds: unknown | null
  product: undefined | null
}

export const useProductStore = defineStore('productStore', {
  state: (): IProductStore => ({
    filters: [],
    crossSell: null,
    goodDeeds: null,
    product: null,
  }),

  actions: {
    setFilter(filters: string[]) {
      this.filters = filters
    },
    clearFilters() {
      this.filters = []
    },
    toggleFilter(filter: string) {
      if (this.filters.includes(filter)) {
        this.filters = this.filters.filter((item) => item !== filter)
      } else {
        this.filters.push(filter)
      }
    },
    async loadCrossSell(params: string) {
      return (await RetailApiV2.get(`cross_sell_products?${params}`)).data?.cross_sell_products ?? null
    },
    async loadGoodDeeds(onlyAvailable: boolean) {
      const { data } = await ApiServiceV1.get('products?permalink=dobre-skutky')

      if (onlyAvailable) {
        return data.products.filter((product: Product) => product.state === 'available')
      }
      return data.products
    },
  },

  getters: {
    getFilters: (state) => state.filters,
    filterCount: (state) => state.filters.length,
    isInFilter: (state) => (filter: string) => state.filters.includes(filter),
    isFavoritesInFilter: (state) => state.filters.includes('favorites'),
  },
})
